import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { adfModelTypeMap, fileTypeLinkedServiceTypes } from '../consts/adf-model-type-map-const';
import {
    jsonCompressionTypeOptions,
    jsonEncodingNameOptions
} from '../consts/v2Dataset-const';
import { compressionCodecType } from 'shell-models-lib';
import { preserveZipFileAsFolderMetadata, preserveCompressionFileAsFolderMetadata } from '../consts/metadata-consts';

export const jsonMetadata: IDatasetTypeMetadata = {
    type: adfModelTypeMap.json.datasetType,
    displayName: stringResources.ModelName_JsonDataset,
    supportLinkedServiceTypes: fileTypeLinkedServiceTypes,
    isSource: true,
    isSink: true,
    datasetKind: 'hierarchical',
    notSupportTypeConversion: true,
    icon: {
        className: 'svg-i-20x20-Json'
    },
    isFirstClass: true,
    supportDataFlowWriteComplexStructure: true,
    category: ['File'],
    isV2FormatDataset: true,
    supportDataFlowSink: true,
    supportDataFlowSource: true,
    supportGetMetadataActivity: true,
    supportDeleteActivity: true,
    compressionOptions: jsonCompressionTypeOptions,
    encodingOptions: jsonEncodingNameOptions,
    compressionReadSettingControls: {
        [compressionCodecType.ZipDeflate]: [preserveZipFileAsFolderMetadata],
        [compressionCodecType.TarGZip]: [preserveCompressionFileAsFolderMetadata],
        [compressionCodecType.tar]: [preserveCompressionFileAsFolderMetadata]
    },
    formatWriteSettingControls: [
        {
            type: 'parameterizable',
            child: {
                type: 'select',
                bind: 'filePattern',
                label: stringResources.Dataset_FileFormat_FilePatternLabel,
                labelPosition: 'left',
                allowClear: true,
                options: [
                    {
                        label: stringResources.Dataset_FileFormat_SetOfObjects,
                        value: 'setOfObjects'
                    },
                    {
                        label: stringResources.Dataset_FileFormat_ArrayOfObjects,
                        value: 'arrayOfObjects'
                    }
                ]
            },
            dynamicContentTextClass: 'input-spaced'
        }
    ],
    fileExtensions: ['*.json', '*']
};
